import { NativeSelectOption } from '@teamsnap/snap-ui/build/components/Input/Input.types';

export const EMPTY_SELECT_VALUE = 'None selected';
export const REGISTRATION_OPTION_LABEL = 'Participant Group';

// backend-defined strings
export enum BackendStaticStrings {
  NO_RESPONSE = 'No response',
}

// The different kinds of questions in the form. Could be dropdown, checkboxes,
// date, text, etc.
export enum QuestionType {
  SELECT = 'select',
  MULTISELECT = 'multiselect',
  DATE = 'date',
  TEXT = 'text',
  PHONE = 'phone',
  EMAIL = 'email',
  TEXTAREA = 'textarea',
  FILE = 'file',
}

// Defines a single option in a dropdown or checkbox question
export type SelectOption = {
  label: string;
  value: string;
  maxQuantity?: number; // Minimum quantity assumed to be 1
  amountRange?: number[]; // [min, max]
};

// Defines a single option in a dropdown question as returned by editable questions API
export type DefaultValue = {
  value: string;
  amount?: number;
  quantity?: number;
};

// Defines a dropdown/checkbox question
export type Question = {
  label: string; // The name of the question
  type: QuestionType; // The type of question that determines what kind of input to render
  options: SelectOption[];
  formFieldId: number; // form field id
  multiselect: boolean; // If true, renders checkboxes. If false, renders dropdown
  defaults: DefaultValue[]; // The default value(s) of the select input
};

// Defines the data type of a participant group returned from the API
export type ParticipantGroup = {
  active: boolean;
  id: number;
  name: string;
  participantFee: number;
};

// Defines the structure of the data returned by the editable_questions endpoint
export type EditableQuestions = {
  formId: number;
  id: number;
  feeRelatedQuestions: Question[]; // Add other question types here if necessary e.g. (SelectQuestion | TextQuestion)[]
  additionalQuestions: Question[];
  registrantEmail: string;
  registrantFirstName: string;
  registrantLastName: string;
  participantInfo?: {
    firstName?: string;
    lastName?: string;
    birthdate?: string;
    city?: string;
    email?: string;
    gender?: string;
    phoneNumber?: string;
    state?: string;
    streetAddress?: string;
    zip?: string;
  };
  guardianInfo?: {
    firstName?: string;
    lastName?: string;
    birthdate?: string;
    city?: string;
    email?: string;
    gender?: string;
    phoneNumber?: string;
    relation?: string;
    state?: string;
    streetAddress?: string;
    zip?: string;
  }[];
  userId: number;
};

// Defines the structure of a question in the form.
// TODO: Refactor "options" to be optional if necessary
export type FormQuestion = {
  id: string;
  type: QuestionType;
  label: string;
  defaults?: DefaultValue[];
  options: (NativeSelectOption | SelectOption)[];
};

// Defines a generic object used to store form values and metadata
export type FormAnswer = {
  value: string;
  details?:  string;
  file?: File;
};

// Defines the type of a Answer as it is returned from or sent to the API
export type APIAnswer = {
  value: string;
  details?: number;
};
